import * as IObjects from '../../../Interfaces/objects';
import { useEffect, useState } from 'react';
const useForm = (callback: Function, validate: Function, submitOnChange?: boolean) => {
    const [values, setValues] = useState<IObjects.GenericObj>({});
    const [errors, setErrors] = useState({});
    const [dirty, setDirty] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    useEffect(() => {
        if (Object.keys(errors).length === 0 && isSubmitting) {
            callback(values);
        }
        // eslint-disable-next-line
    }, [errors]);

    useEffect(() => {
        //useful for forms that contain only a toggle or checkbox
        if (submitOnChange && Object.keys(dirty).length) handleSubmit();
        setDirty({});
        // eslint-disable-next-line
    }, [values]);

    const handleSubmit = (event?: React.FormEvent<HTMLFormElement>) => {
        if (event) event.preventDefault();
        setErrors(validate(values));
        setIsSubmitting(true);
    };

    //Supports text, select and toggle/checkbox
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.persist) event.persist();
        setDirty(dirty => ({
            ...dirty,
            [event.target.name]: true,
        }));
        setValues(values => ({
            ...values,
            [event.target.name]: event.target.type === 'checkbox' ? event.target.checked : event.target.value,
        }));
    };

    return {
        errors,
        handleChange,
        handleSubmit,
        setValues,
        values,
    };
};

export default useForm;
